module.exports = "https://www.gc-pro.gnp.com.mx/fc0e17c3bd14a3bacc2da9855ad9600e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/visa-card.png
// module id = 1066
// module chunks = 0